import { render, staticRenderFns } from "./CGridItem.vue?vue&type=template&id=6cd85438&"
import script from "./CGridItem.vue?vue&type=script&lang=js&"
export * from "./CGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports